export default function Hero() {
  return (
    <section id="top" className="w-full border-b border-background-200 bg-background-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 items-center gap-10 lg:gap-14">
          <div className="lg:col-span-7 animate-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-100/70 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-flashlight-line" />
              黑料看料 · 每日热度更新
            </span>

            <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold leading-tight text-foreground-950">
              黑料看料盘点：
              <span className="text-primary-600">热门人物事件</span>
              一览
            </h1>

            <p className="mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-700">
              黑料看料首页汇总近期热门人物与事件的黑料盘点，按话题热度整理清单与目录，
              把散落各处的公开信息归拢到一条时间线上，方便快速掌握当前讨论焦点。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#roundup"
                className="inline-flex h-11 items-center justify-center gap-2 rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-list-check-2 text-base" />
                查看完整清单
              </a>
              <a
                href="#directory"
                className="inline-flex h-11 items-center justify-center gap-2 rounded-md border border-background-300 bg-background-50 px-6 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-folder-open-line text-base" />
                浏览看料目录
              </a>
            </div>

            <dl className="mt-10 flex flex-wrap gap-x-10 gap-y-4">
              <div>
                <dt className="text-xs text-foreground-500">收录条目</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-foreground-950">1,284</dd>
              </div>
              <div>
                <dt className="text-xs text-foreground-500">今日更新</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-foreground-950">86</dd>
              </div>
              <div>
                <dt className="text-xs text-foreground-500">进行中话题</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-accent-600">37</dd>
              </div>
            </dl>
          </div>

          <div className="lg:col-span-5 animate-fade-up" style={{ animationDelay: "120ms" }}>
            <figure className="relative overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <div className="w-full h-[320px] md:h-[460px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Stilized%20abstract%20editorial%20illustration%20of%20layered%20paper%20document%20sheets%20floating%20in%20space%2C%20warm%20terracotta%20amber%20and%20cream%20palette%2C%20geometric%20clean%20composition%2C%20soft%20long%20shadows%2C%20subtle%20grain%20texture%2C%20generous%20negative%20space%2C%20no%20people%2C%20no%20text%2C%20high%20detail&width=900&height=1080&seq=heliao-hero-01&orientation=portrait"
                  alt="黑料看料盘点 资料卡片与时间线示意"
                  title="黑料看料盘点 黑料看料一览"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/70 to-transparent p-4 md:p-5">
                <p className="text-xs text-background-50/80">今日焦点</p>
                <p className="mt-1 text-sm md:text-base font-medium text-background-50">
                  解约风波与番位调整，成为当前讨论最集中的两条线
                </p>
              </div>
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
}